import styled from "styled-components";
import InviteBg from "../../assets/images/invite-bg.png";

export const InviteRecardContain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
`;
export const ProcessCard = styled.div`
  height: 238px;
  width: 100%;
  display: flex;
  background-image: url(${InviteBg});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #292b2f;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
`;

export const CardItem = styled.div<{ isPictureUser: boolean }>`
  display: flex;
  align-items: center;
  position: relative;
  max-width: ${({ isPictureUser }) => (isPictureUser ? "20%" : "40%")};
  > div {
    text-align: center;
  }
  .icon {
    width: 120px;
  }
  .num-text {
    position: absolute;
    left: -10px;
  }
`;
export const CardVector = styled.div<{ isPictureUser: boolean }>`
  margin: 0 10px;
  flex: 1;
  max-width: ${({ isPictureUser }) => (isPictureUser ? "132px" : "unset")};
`;
export const InviteRewardBottom = styled.div`
  display: flex;
  gap: 17px;
  flex: 1 1 0%;
  margin-bottom: 20px;
`;
export const InviteRewardLeft = styled.div`
  width: 677px;
  border-radius: 4px;
  background: #292b2f;
  padding: 24px;

  p {
    color: #939393;
  }
  input {
    color: #ffffff !important;
    background: #262626 !important;
  }
  .renderbus-ui--input.ant-input-disabled {
    background: #262626 !important;
  }
  .ant-input {
    margin-right: 10px;
  }
  .ant-input-prefix {
    color: #ffffff;
  }
  .ant-input-affix-wrapper {
    background: #262626;
  }
  button {
    height: 28px;
    display: flex;
    align-items: center;
  }
  .share-poster-btn,
  .share-poster-btn:hover {
    background: #13cb750d !important;
    border: 1px solid #13cb75 !important;
    color: #13cb75 !important;
    padding: 0 10px;
  }
`;
export const InviteTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  &::before {
    display: inline-block;
    content: "";
    width: 3px;
    height: 13px;
    margin-right: 8px;
    background: #13cb75;
  }
`;

export const ShareChannelText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #d9dfe0;
  margin-top: 12px;
`;

export const ChannelIconWrapper = styled.div`
  display: flex;
  gap: 6px;
  margin: 8px 0 16px;
`;

export const ChannelIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #13161b;
  width: 32px;
  height: 32px;
  border: 0.7px solid #687778;
  border-radius: 50%;
`;
